import {createAction, props} from '@ngrx/store';


export const CookiesLogin = createAction(
  '[Login] Cookies Login'
);

export const loadLogins = createAction(
  '[Login] Load Logins'
);

export const loginUser = createAction(
  '[Login] Login User',
  props<{ email: string, password: string }>()
);

export const loginUserSuccess = createAction(
  '[Login] Login User Success',
  props<{ userData: any }>()
);


export const loginUserFailed = createAction(
  '[Login] Login User Failed',
  props<{ code: number, error: string }>()
);

export const forgetPassword = createAction(
  '[Login] Forget Password',
  props<{ email: string }>()
);
export const forgetPasswordSuccess = createAction(
  '[Login] Forget Password Success'
);


export const LogoutUser = createAction(
  '[Login] Logout User'
);

export const LogoutUserSuccess = createAction(
  '[Login] Logout User Success'
);
export const forgetPasswordFailed = createAction(
  '[Login] Forget Password Failed',
  props<{ error: string }>()
);
